import { MeetHttpHelper, NO_DATA_MESSAGE } from '../../../utils/HttpHelper';

const PostMeetUploadErrorTankMatchByMemberIdData = (meetId, matchingMemberObj, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    const meetIdForUrl = meetId ? encodeURIComponent(meetId) : 'NaN';
    const url = `/Meet/TimesUpload/MatchedPersonMemberFromError?meetId=${meetIdForUrl}`;
    MeetHttpHelper(url, 'POST', matchingMemberObj)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData: objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default PostMeetUploadErrorTankMatchByMemberIdData;